import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/store/Home";
import Catalog from "@/pages/store/Catalog";
import ProductPage from "@/pages/store/ProductPage";
import Cart from "@/pages/store/Cart";
import Checkout from "@/pages/store/Checkout";
import OrderSuccess from "@/pages/store/OrderSuccess";
import Account, { FavoritesPage, ResetPassword } from "@/pages/store/Account";
import { CustomPage, CompaniesPage, PolicyPage, BlogList, BlogPost } from "@/pages/store/Pages";
import AdminLayout, { AdminLogin, Guard } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import { OrdersList, OrderDetail } from "@/pages/admin/Orders";
import Production from "@/pages/admin/Production";
import { ProductsList, ProductForm } from "@/pages/admin/Products";
import { Inventory, Customers, CustomerDetail, Finance, Reports } from "@/pages/admin/Modules";
import { Users, Logs, Carts, Settings } from "@/pages/admin/System";
import Crud from "@/pages/admin/Crud";
import Print from "@/pages/admin/Print";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const G = (mod, el) => <Guard mod={mod}>{el}</Guard>;

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route element={<StoreLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Catalog />} />
            <Route path="/produto/:slug" element={<ProductPage />} />
            <Route path="/carrinho" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pedido/sucesso" element={<OrderSuccess />} />
            <Route path="/pedido/status" element={<OrderSuccess />} />
            <Route path="/minha-conta" element={<Account />} />
            <Route path="/minha-conta/redefinir-senha" element={<ResetPassword />} />
            <Route path="/favoritos" element={<FavoritesPage />} />
            <Route path="/personalizados" element={<CustomPage />} />
            <Route path="/empresas" element={<CompaniesPage />} />
            <Route path="/politicas/:slug" element={<PolicyPage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<div className="py-32 text-center"><h1 className="text-4xl font-bold">Página não encontrada</h1></div>} />
          </Route>
          <Route path="/administrativo/login" element={<AdminLogin />} />
          <Route path="/administrativo/redefinir-senha" element={<ResetPassword admin />} />
          <Route path="/administrativo/imprimir/:kind/:id" element={<AdminLayoutPrint />} />
          <Route path="/administrativo" element={<AdminLayout />}>
            <Route index element={G("dashboard", <Dashboard />)} />
            <Route path="pedidos" element={G("pedidos", <OrdersList />)} />
            <Route path="pedidos/:id" element={G("pedidos", <OrderDetail />)} />
            <Route path="producao" element={G("producao", <Production />)} />
            <Route path="maquinas" element={G("maquinas", <Crud res="printers" />)} />
            <Route path="produtos" element={G("produtos", <ProductsList />)} />
            <Route path="produtos/:id" element={G("produtos", <ProductForm />)} />
            <Route path="categorias" element={G("categorias", <Crud res="categories" />)} />
            <Route path="estoque" element={G("estoque", <Inventory />)} />
            <Route path="filamentos" element={G("filamentos", <Crud res="filaments" />)} />
            <Route path="clientes" element={G("clientes", <Customers />)} />
            <Route path="clientes/:id" element={G("clientes", <CustomerDetail />)} />
            <Route path="financeiro" element={G("financeiro", <Finance />)} />
            <Route path="cupons" element={G("cupons", <Crud res="coupons" />)} />
            <Route path="avaliacoes" element={G("avaliacoes", <Crud res="reviews" />)} />
            <Route path="fretes" element={G("fretes", <Settings initialTab="frete" />)} />
            <Route path="banners" element={G("banners", <Crud res="banners" />)} />
            <Route path="orcamentos" element={G("orcamentos", <Crud res="quotes" />)} />
            <Route path="carrinhos" element={G("carrinhos", <Carts />)} />
            <Route path="blog" element={G("blog", <Crud res="posts" />)} />
            <Route path="relatorios" element={G("relatorios", <Reports />)} />
            <Route path="usuarios" element={G("usuarios", <Users />)} />
            <Route path="configuracoes" element={G("configuracoes", <Settings />)} />
            <Route path="logs" element={G("logs", <Logs />)} />
          </Route>
        </Routes>
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </StoreProvider>
  );
}

function AdminLayoutPrint() {
  const [ok, setOk] = useState(undefined);
  const loc = useLocation();
  useEffect(() => { api.get("/admin/auth/me").then(() => setOk(true)).catch(() => setOk(false)); }, []);
  if (ok === undefined) return null;
  if (!ok) return <Navigate to={`/administrativo/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return <Print />;
}

export default App;
